import React from 'react';
import styled from 'styled-components';
import { SocialImage, StyleSocialButtons } from '../Welcome/Welcome';
import GooglePlayImg from '../../assets/icons/googleplay-active.svg';
import AppStoreImg from '../../assets/icons/appstore-active.svg';

const feedbacks = [
  { src: '/feedback/1.jpg' },
  { src: '/feedback/2.jpg' },
  { src: '/feedback/3.jpg' },
  { src: '/feedback/4.jpg' },
  { src: '/feedback/5.jpg' },
  { src: '/feedback/6.jpg' },
  { src: '/feedback/7.jpg' },
  { src: '/feedback/8.jpg' },
  { src: '/feedback/9.jpg' },
  { src: '/feedback/10.jpg' },
  { src: '/feedback/11.jpg' },
  { src: '/feedback/12.jpg' },
  { src: '/feedback/13.jpg' },
  { src: '/feedback/14.jpg' },
  { src: '/feedback/15.jpg' }
];

const FeedbackAppComponent = () => {
  return (
    <FeedbackAppWrapper>
      <FeedbackAppWrapperInfo>
        <span>
          Более <b>1 000 000 пользователей</b>
        </span>
        <h3>Скачать мобильное приложение EnerGo</h3>
        <StyleSocialButtons>
          <a href="https://apps.apple.com/ru/app/energo-%D0%B0%D1%80%D0%B5%D0%BD%D0%B4%D0%B0-%D0%BF%D0%B0%D0%B2%D0%B5%D1%80%D0%B1%D0%B0%D0%BD%D0%BA%D0%BE%D0%B2/id1507114521">
            <SocialImage src={AppStoreImg} alt="app-store" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.energo.rnapp&hl=ru&gl=US">
            <SocialImage src={GooglePlayImg} alt="app-store" />
          </a>
        </StyleSocialButtons>
      </FeedbackAppWrapperInfo>
      <FeedbackAppComments>
        <FeedbackAppCol>
          <FeedbackAppColWrapper>
            {feedbacks.map(
              ({ src }, index) =>
                index < 5 && <img key={index} src={src} alt="feedback" />
            )}
          </FeedbackAppColWrapper>
          <FeedbackAppColWrapper>
            {feedbacks.map(
              ({ src }, index) =>
                index < 10 &&
                index >= 5 && <img key={index} src={src} alt="feedback" />
            )}
          </FeedbackAppColWrapper>
          <FeedbackAppColWrapper>
            {feedbacks.map(
              ({ src }, index) =>
                index >= 10 && <img key={index} src={src} alt="feedback" />
            )}
          </FeedbackAppColWrapper>
          <FeedbackAppColWrapperHidden>
            {feedbacks.map(
              ({ src }, index) =>
                index < 6 && <img key={index} src={src} alt="feedback" />
            )}
          </FeedbackAppColWrapperHidden>
          <FeedbackAppColWrapperHidden>
            {feedbacks.map(
              ({ src }, index) =>
                index > 6 && <img key={index} src={src} alt="feedback" />
            )}
          </FeedbackAppColWrapperHidden>
        </FeedbackAppCol>
      </FeedbackAppComments>
    </FeedbackAppWrapper>
  );
};

const FeedbackAppWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 56px;
  @media (max-width: 1135px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const FeedbackAppComments = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 384px - 30px);
  @media (max-width: 1135px) {
    width: 100%;
  }
`;

const FeedbackAppCol = styled.div`
  height: 560px;
  overflow: hidden;
  display: flex;
  @media (max-width: 600px) {
    height: 400px;
  }
`;

const FeedbackAppColWrapper = styled.div`
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  cursor: pointer;
  width: calc((100%) / 3);
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  & img {
    width: 100%;
  }
  @media (max-width: 599px) {
    width: 100%;
    display: none;
  }
`;

const FeedbackAppColWrapperHidden = styled.div`
  display: none;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  cursor: pointer;
  width: calc((100%) / 3);
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  & img {
    width: 100%;
  }
  @media (max-width: 599px) {
    width: 100%;
    display: block;
  }
`;

const FeedbackAppWrapperInfo = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 384px;
  & span {
    font-weight: 400;
    font-size: 18px;
    color: #606872;
    & b {
      text-decoration: underline;
      color: #26292d;
      cursor: pointer;
    }
  }
  & h3 {
    font-weight: 400;
    font-size: 28px;
    margin-top: 24px;
  }
  & div {
    margin-top: 24px;
    justify-content: flex-start;
    gap: 8px;
    & img {
      margin-left: 0px;
    }
  }
  @media (max-width: 1135px) {
    max-width: 100%;
  }
`;

export default FeedbackAppComponent;
